import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';

@Component({
  selector: 'app-set-environment-audit-action',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatRadioModule, LabelsProviderPipe],
  templateUrl: './set-environment-audit-action.component.html',
  styleUrl: './set-environment-audit-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetEnvironmentAuditActionComponent {
  public fg = input.required<UntypedFormGroup>();
  public playbooksActionInput = input.required<PlaybooksActionDefinitionInput>();
  public triggerType = input.required<TriggerTypes>();
  public auditMode = model<boolean>(true);

  public onRadioButtonChange(value: boolean) {
    this.auditMode.set(value);
  }
}
